import { render, staticRenderFns } from "./ActiveRuleList.vue?vue&type=template&id=13b47bd2&"
import script from "./ActiveRuleList.vue?vue&type=script&lang=js&"
export * from "./ActiveRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports